module.exports = __webpack_public_path__ + "static/media/practice-skills@3x.605eee02.png";